import { render, staticRenderFns } from "./ProductDesignSubmitView2.vue?vue&type=template&id=b4e55ae8&"
import script from "./ProductDesignSubmitView2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignSubmitView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports